export default __webpack_public_path__ + "static/media/FinalMaybe.69d91ed6.png";